import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { api, callableErrorMessage } from "../lib/api";
import { rememberRedirect } from "../lib/redirectAfter";

export function AcceptStaffInvite() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const tenantId = params.get("tenant") ?? "";
  const token = params.get("token") ?? "";
  const { user, loading } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      rememberRedirect(`/staff/aceptar?tenant=${tenantId}&token=${token}`);
      nav("/login", { replace: true });
    }
  }, [loading, user, nav, tenantId, token]);

  const accept = async () => {
    setBusy(true);
    setError(null);
    try {
      await api.acceptStaffInvite({ tenantId, token });
      window.location.assign("/staff/cobro");
    } catch (err) {
      setError(callableErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  if (loading || !user) return <div className="grid min-h-dvh place-items-center bg-cream">Cargando…</div>;

  return (
    <main className="min-h-dvh bg-cream">
      <div className="container-page flex flex-col gap-6">
        <header className="text-center">
          <p className="text-xs uppercase tracking-[0.2em] text-leaf-600">Fideliza</p>
          <h1 className="mt-2 font-display text-2xl font-semibold text-leaf-950">
            Invitacion como cajero
          </h1>
          <p className="mt-2 text-sm text-leaf-700">
            Estas por unirte a <strong>{tenantId}</strong> como cajero. Podras escanear el QR de los
            clientes y registrar ventas.
          </p>
        </header>
        <div className="card flex flex-col gap-3">
          <p className="text-sm text-leaf-800">
            Logueado como <strong>{user.email}</strong>
          </p>
          {error && (
            <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error}
            </div>
          )}
          <button onClick={accept} disabled={busy} className="btn-primary">
            {busy ? "Aceptando…" : "Aceptar invitacion"}
          </button>
        </div>
      </div>
    </main>
  );
}
